import { PRODUCT_RATING, PRODUCT_REVIEWS, REVIEW_DETAILS } from 'elc-service-view-names';
import { Service, ServiceInitializer } from 'elc-service';
import { serviceNames, diContainer } from './diContainer';
import { RatingsReviewsServiceStartedUseCase } from '../internal/use-cases/RatingsReviewsServiceStartedUseCase';

const { name, version } = __serviceInfo__;

export class RatingsReviewsService extends Service {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
        this.registerView(
            PRODUCT_RATING,
            () =>
                import(
                    /* webpackChunkName: 'ProductRating' */
                    '../exported/product-rating/ProductRating'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.productRatingViewController)
        );
        this.registerView(
            PRODUCT_REVIEWS,
            () =>
                import(
                    /* webpackChunkName: 'ProductReviews' */
                    '../exported/product-reviews/ProductReviews'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.productReviewsViewController)
        );
        this.registerView(
            REVIEW_DETAILS,
            () =>
                import(
                    /* webpackChunkName: 'ReviewDetails' */
                    '../exported/review-details/ReviewDetails'
                ),
            // @ts-ignore
            () => diContainer.get(serviceNames.reviewDetailsViewController)
        );
    }

    // tslint:disable-next-line:no-any
    public async start(config: any) {
        await super.start(config);

        const useCase = new RatingsReviewsServiceStartedUseCase([
            'apiKey',
            'locale',
            'merchantGroupId',
            'merchantId',
            'pageId',
            'reviewWrapperUrl',
            'reviewDisplaySnapshotType'
        ]);
        await useCase.execute();
    }
}
